"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const fev1 = schema_1.Schema.number()
    .unit("%")
    .integer()
    .max(200)
    .minExclusive(0)
    .interpretation({
    vocab: "ltx",
    code: "forced_expiratory_volume_1_second"
});
const fvc = schema_1.Schema.number()
    .unit("%")
    .integer()
    .max(200)
    .minExclusive(0)
    .interpretation({ vocab: "ltx", code: "forced_vital_capacity" });
const pef = schema_1.Schema.number()
    .optional()
    .unit("%")
    .integer()
    .max(200)
    .minExclusive(0)
    .interpretation({ vocab: "ltx", code: "peak_expiratory_flow" });
const mef75 = schema_1.Schema.number()
    .optional()
    .unit("%")
    .integer()
    .max(200)
    .minExclusive(0)
    .interpretation({ vocab: "ltx", code: "maximal_expiratory_flow_at_75" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ fev1, fvc, pef, mef75 })
    .interpretation({ vocab: "ltx", code: "pulmonary_function_test" });
